/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Ошибка на стороне сервиса
 */
export interface GenericError {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Базовая информация о Начислении
 */
export interface BaseCharge {
  /** @format uuid */
  id?: string;
  state?: string;
  number?: string;

  /** @format date */
  date?: string;

  /** УИН */
  chargedataSupplierBillId?: string;

  /** Номер расчетного счета получателя */
  paydocdataPayeePayeeaccountinfoPersonalAcc?: string;

  /** ИНН получателя */
  paydocdataPayeeInn?: string;

  /** Сумма счета */
  paydocdataAmountToPay?: number;

  /** Наименование получателя */
  paydocdataPayeePayeeName?: string;
}

/**
 * Списковая структура для Начислений
 */
export interface ChargeListWrapper {
  hasMore?: boolean;
  data?: BaseCharge[];
}

/**
 * Детальная информация о Начислении
 */
export interface Charge {
  /** @format uuid */
  id?: string;
  paymentId?: string;
  paymentState?: string;
  paymentStateDescription?: string;
  state?: string;
  number?: string;

  /**
   * Время корректировки начисления
   * @format date-time
   */
  updateEventTimestamp?: string;

  /**
   * Время отзыва начисления
   * @format date-time
   */
  revokeEventTimestamp?: string;

  /**
   * Время исполнения платежного документа
   * @format date-time
   */
  executePaymentTimestamp?: string;

  /** @format date */
  date?: string;

  /** @format date-time */
  incomeTimestamp?: string;

  /** @format date-time */
  lastUpdateStateTimestamp?: string;
  informationType?: string;
  idRq?: string;
  timestampRq?: string;
  routingCode?: string;
  reasonSend?: string;
  paymentPayerAcc?: string;
  paymentPayerBankName?: string;
  paymentPayerBankBik?: string;
  paymentPayerBankCorrespAcc?: string;
  paydocdataInvoiceId?: string;
  paydocdataOperationId?: string;

  /** @format date */
  paydocdataInvoiceDate?: string;
  paydocdataSignAmountTax?: string;
  paydocdataTax?: string;
  paydocdataAmountTax?: number;
  paydocdataAmount?: number;
  paydocdataAmountToPay?: number;
  paydocdataCurrencyCode?: string;
  paydocdataPurpose?: string;

  /** @format date */
  paydocdataValidUntil?: string;
  paydocdataPayeePayeeName?: string;
  paydocdataPayeeInn?: string;
  paydocdataPayeeKpp?: string;
  paydocdataPayeePayeeaccountinfoPersonalAcc?: string;
  paydocdataPayeePayeeaccountinfoBankBankName?: string;
  paydocdataPayeePayeeaccountinfoBankBik?: string;
  paydocdataPayeePayeeaccountinfoBankCorrespAcc?: string;
  paydocdataPayerorgPayerName?: string;
  paydocdataPayerorgInn?: string;
  paydocdataPayerorgKpp?: string;
  chargedataSupplierBillId?: string;
  chargedataPayeeName?: string;
  chargedataPurpose?: string;
  chargedataAmount?: string;
  budgetPayerStatus?: string;
  budgetKbk?: string;
  budgetOktmo?: string;
  budgetTaxDocNumber?: string;
  budgetTaxDocDate?: string;
  acceptAmountAccept?: number;
  acceptPayeraccountinfoPersonalAcc?: string;
  acceptPayeraccountinfoBankBankName?: string;
  acceptPayeraccountinfoBankBik?: string;
  acceptPayeraccountinfoBankCorrespAcc?: string;
  acceptDocumentbaseName?: string;
  acceptDocumentbaseNumber?: string;

  /** @format date */
  acceptDocumentbaseDate?: string;

  /** @format date */
  acceptExpirationAuthority?: string;
}

export interface GetListParams {
  /**
   * @format int32
   * @example 0
   */
  offset: number;

  /**
   * @format int32
   * @example 10
   */
  size: number;

  /** @format date */
  beginDate?: string;

  /** @format date */
  endDate?: string;
  state?: string[];
  searchText?: string;
}

import { HttpClient } from "../../client";
import { RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-ms-prd-one-window
 * @version 1.0
 * @license Ссылка на проект в JIRA (https://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=135870867)
 * @baseUrl https://owb-ms-prd-one-window.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ <info@rshbintech.ru> (https://rshbintech.ru/)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Начисления - Cвой Бизнес
     * @name LinkPaymentCharge
     * @summary Создание связи начисления с платежкой
     * @request PUT:/api/one-window/v1/external/charges/{chargeId}/link-payment/{paymentId}
     * @secure
     */
    linkPaymentCharge: (
      paymentId: string,
      chargeId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, GenericError>({
        path: `/api/one-window/v1/external/charges/${chargeId}/link-payment/${paymentId}`,
        method: "PUT",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Начисления - Cвой Бизнес
     * @name GetList
     * @summary Получение списка начислений
     * @request GET:/api/one-window/v1/external/charges
     * @secure
     */
    getList: (query: GetListParams, params: RequestParams = {}) =>
      this.request<ChargeListWrapper, GenericError>({
        path: `/api/one-window/v1/external/charges`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Начисления - Cвой Бизнес
     * @name GetById
     * @summary Получение детальной информации о начислении
     * @request GET:/api/one-window/v1/external/charges/{id}
     * @secure
     */
    getById: (id: string, params: RequestParams = {}) =>
      this.request<Charge, GenericError>({
        path: `/api/one-window/v1/external/charges/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
